import { Component, ViewChild, TemplateRef, ElementRef, OnInit } from '@angular/core';
import { AppService } from 'src/app/app.service';
import { messageService } from 'src/app/message.service';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { Router } from '@angular/router';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SuccessSnackbarComponent } from 'src/app/support/success-snackbar/success-snackbar.component';
import { PaginationService } from 'src/app/PaginationService';
import { DynamicAuditTrailComponent } from '../support/dynamic-audit-trail/dynamic-audit-trail.component';
import { ExcelPdfComponent } from '../support/excel-pdf/excel-pdf.component';
import { GridReorderComponent } from '../grid-reorder/grid-reorder.component';

export interface PopupData {
  title: string;
}

@Component({
  selector: 'app-qms-questionnaire-template',
  templateUrl: './qms-questionnaire-template.component.html',
  styleUrls: ['./qms-questionnaire-template.component.scss']
})
export class QmsQuestionnaireTemplateComponent implements OnInit {

  snackbarRef: any;
  searchText: any;
  searchValue: any;
  isProcessing = true;
  _temp: any = {};
  columnLists: any = {};
  qmsQuestionnaireTemplateDataForGrid: any = [];
  makeStickyColumns: any;
  dataTypeList: any = [];

  auditTrail: any = {};
  visibleAuditTrail: boolean = false;
  oddTemplateType: any = false;

  constructor(public dialog: MatDialog, private readonly appService: AppService, public router: Router, private readonly snackBar: MatSnackBar,
    public paginationService: PaginationService, public message: messageService, private readonly elem: ElementRef) {

    const data: any = router.getCurrentNavigation()?.extras.state;
    data?.fromQuestionTemplate && (this.selectedModule = this.message.questionnaireModule) && this.getcallMethod();
  }

  visibleDataGrid: boolean = false;
  itemsPerPage = 5;
  currentPage = 1;
  totalPages = 0;
  maxSize = 3;
  collectionSize: number;
  perPage = 10;
  calculateTotalPages: number;

  showingResultsText = "Showing results";
  displayingClaimsText = "Displaying claims";
  rowText = "Rows";
  showingRowsText = "Showing rows";
  private readonly users: any[];
  pager: any = {};
  pagedItems: any[];
  error = '';
  setPage(page: number, targetpage: number) {
    if (page < 1 || page > this.pager.totalPages) {
      return;
    }
    if (Number.isNaN(page)) {
      page = 1;
    }

    this.pager = this.paginationService.getPager(this.qmsQuestionnaireTemplateDataForGrid.length, page, this.perPage, targetpage);
    this.pagedItems = this.qmsQuestionnaireTemplateDataForGrid
      .slice(this.pager.startIndex, this.pager.endIndex + 1);
  }

  paginationCall(value: number) {
    this.perPage = value;
    this.setPage(this.pager.currentPage, 0);
  }

  getcallMethod() {
    this.qmsQuestionnaireTemplateDataForGrid = [];
    const data = {

      gridName: "QUESTIONNAIRE_TEMPLATE"
    }
    this.appService.getDynamicGridHeaders(data).subscribe({
      next: (response: any) => {

        response.orderByClause ??= "";

        this.makeStickyColumns = response.fixedFieldCnt;

        const data1: any = {

          gridName: "QMS_QUESTIONNAIRE_TEMPLATES_VW",
          tableOrViewName: response.tableOrViewName ?? "",
          columnsList: response.columnsList ?? "",
          fieldLabelsList: response.fieldLabelsList ?? "",
          invisibleColumn: response.invisibleColumn ?? "",
          orderByClause: response.orderByClause ?? "",
          fieldSizeList: response.fieldSizeList ?? "",
          columnsListarray: [],
          fieldColumnarray: [],
          invisibleColumnarray: [],
          fieldSizeListArray: [],
          manualEntryDataFields: response.manualEntryDataFields,
          clobColumnlist: response.closblist || "",
          blobColumnlist: response.bloblist || "",
          module: this.selectedModule
        }
        this.reportObj = { ...data1, ...data };
        this.appService.getDynamicGridData(data1).subscribe({
          next: (response1: any) => {
            this.qmsQuestionnaireTemplateDataForGrid = response1;
            this.visibleAuditTrail = false;
            data1.columnsListarray = data1.columnsList.split(",");
            data1.fieldColumnarray = data1.fieldLabelsList.split(",");
            data1.invisibleColumnarray = data1.invisibleColumn.split(",");
            data1.fieldSizeListArray = data1.fieldSizeList.split(",");
            let rendereddata: any;
            this.columnLists.columnsListarray = data1.columnsListarray;
            this.columnLists.fieldLabelsList = data1.fieldLabelsList;
            this.columnLists.fieldColumnarray = [];
            for (let p = 0; p < data1.fieldColumnarray.length; p++) {
              this.columnLists.fieldColumnarray.push({
                "fieldColumnarray": data1.fieldColumnarray[p],
                "width": data1.fieldSizeListArray[p] + 'px'
              })
            }
            this.columnLists.invisibleColumnarray = data1.invisibleColumnarray;
            this.columnLists.fieldSizeListArray = [];
            for (const size of data1.fieldSizeListArray) {
              this.columnLists.fieldSizeListArray.push(size + 'px');
            }

            let y = 0;
            while (y < this.columnLists.columnsListarray.length) {
              const currentColumn = this.columnLists.columnsListarray[y];
              const isInvisible = this.columnLists.invisibleColumnarray.includes(currentColumn);
              if (isInvisible) {
                this.columnLists.columnsListarray.splice(y, 1);
                this.columnLists.fieldColumnarray.splice(y, 1);
                this.columnLists.fieldSizeListArray.splice(y, 1);
              } else {
                y++;
              }
            }

            let tableData = {
              tablename: data1.tableOrViewName
            };
            this.columnLists.columnsListarray1 = [];
            this.appService.tableFieldsDataType(tableData).subscribe((response2: any) => {
              this.dataTypeList = response2;
              for (let m = 0; m < this.columnLists.columnsListarray.length; m++) {
                this.columnLists.columnsListarray1.push({});
                this.columnLists.columnsListarray1[m].columnsListarray = this.columnLists.columnsListarray[m];
                this.columnLists.columnsListarray1[m].dataType = "textbox";
                this.columnLists.columnsListarray1[m].width = this.columnLists.fieldSizeListArray;
                for (const dataType of this.dataTypeList) {
                  if (dataType.columnName == this.columnLists.columnsListarray[m]) {
                    this.columnLists.columnsListarray1[m].dataType = dataType.fieldType;
                  }
                }
              }
              for (const questionnaire of this.qmsQuestionnaireTemplateDataForGrid) {

                for (const dataType of this.dataTypeList) {
                  if (dataType.fieldType === 'CHECKBOX') {
                    questionnaire[dataType.columnName] = questionnaire[dataType.columnName] === 'Y';
                  }
                }
              }
              this.calculateTotalPages = this.collectionSize / this.perPage;
              this.pager.totalPages = undefined;
              this.setPage(1, 0);
            });
            this.message.gridList = this.qmsQuestionnaireTemplateDataForGrid;
            this.collectionSize = this.qmsQuestionnaireTemplateDataForGrid.length;
            this.totalPages = Math.ceil(this.qmsQuestionnaireTemplateDataForGrid.length / this.itemsPerPage);
            this.dynamicLabelCall();
          }, error: (error) => {
            this.isProcessing = false;
            throw error;
          }
        });
        this.isProcessing = false;
      }, error: (error) => {
        this.isProcessing = false;
        throw error;
      }
    });
  }

  applyFilter3(column: string, event: Event): void {
    const filter = (event.target as HTMLInputElement).value.trim().toLowerCase();
    if (filter === '') {
      this.pagedItems = this.qmsQuestionnaireTemplateDataForGrid.slice(this.pager.startIndex, this.pager.endIndex + 1);
    } else {
      this.pagedItems = this.qmsQuestionnaireTemplateDataForGrid.filter((item: any) =>
        item[column]?.toLowerCase().includes(filter)
      );
    }
  }

  counts: any;
  cssfunction(ix: number) {
    let elements1 = this.elem.nativeElement.querySelectorAll('.sticky-dynamic-col1');
    let index1 = 1;
    let headerWidth = 0;
    elements1.forEach((header: any, key: any) => {
      for (let i = 1; i <= this.makeStickyColumns; i++) {
        if (index1 == i) {
          header.style.position = 'sticky';
          header.style.background = 'white';
          if (index1 > 1) {
            headerWidth += 200;
            header.style.left = headerWidth + 'px';
          } else {
            headerWidth = 60;
            header.style.left = headerWidth + 'px';
          }
        }
      }
      index1++;
    })

    let elements2 = this.elem.nativeElement.querySelectorAll('.sticky-dynamic-row1');
    let index2 = 1;
    let lengthOfColumns = this.columnLists.columnsListarray1.length;
    let colWidth = 0;
    elements2.forEach((column: any, key: any) => {
      for (let j = 1; j <= this.makeStickyColumns; j++) {
        if (index2 == j) {
          column.style.position = 'sticky';
          column.style.background = 'white';
          column.style.textDecoration = "underline";
          column.style.color = "blue";
          column.style.cursor = "pointer";
          if (index2 > 1) {
            colWidth += 200;
            let previousColumn = elements2[key - 1];
            console.log(previousColumn.style.width);
            column.style.left = colWidth + 'px';
          } else {
            colWidth = 60;
            column.style.left = colWidth + 'px';
          }
        }
      }
      if (index2 == (lengthOfColumns - 1)) {
        index2 = 0;
      } else {
        index2++;
      }
    })
  }

  detailsData(clickedQuestionnaire: any, idx: number) {
    this.snackbarRef?.dismiss?.();
    const matchingQuestionnaire = this.qmsQuestionnaireTemplateDataForGrid.find((questionnaire: any) => questionnaire.TEMPLATE_ID == clickedQuestionnaire.TEMPLATE_ID);
    this.message.templateIdFromQmsQuestionnaireTemplate = matchingQuestionnaire.TEMPLATE_ID;
    this.router.navigate(['dashboard/qmsQuestionnaireTemplateQuestion'], {
      state: { template: matchingQuestionnaire }
    });
  }

  parentCheckBox: boolean = false;
  childCheckBoxs: boolean = false;

  dataGridParentCheckBoxChecked(e: any) {
    const isChecked = e.target.checked;

    this.childCheckBoxs = isChecked;

    for (const questionnaire of this.qmsQuestionnaireTemplateDataForGrid) {
      questionnaire.childCheckBoxs = isChecked;
    }
  }

  previousIdx: any;
  dataGridChildCheckBoxChecked(e: any, list: any, idx: any) {
    if (e.target.checked) {
      if (this.previousIdx != undefined) {
        this.qmsQuestionnaireTemplateDataForGrid[this.previousIdx].childCheckBoxs = false;
      }
      list.childCheckBoxs = true;
      this.auditTrail.refNo = list.TEMPLATE_ID;
    } else {
      list.childCheckBoxs = false;
    }
    this.visibleAuditTrail = this.qmsQuestionnaireTemplateDataForGrid.some((list: any) => list.childCheckBoxs);
    this.previousIdx = idx;
  }


  dropDownDataForTemplateType: any = [];
  dropdownForModule: any = [];
  moduleDropdown: any = [];
  selectedModule: any = null;
  moduleSearchText: any;
  ngOnInit() {
    this.dropdownForModule = JSON.parse(sessionStorage.getItem('dropDownForModules') ?? '{}');
    this.selectBoxForModule();
    this.appService.getCodeListsByGroup("AU_TYPE").subscribe((data: any) => {
      this.dropDownDataForTemplateType = data;
      this.selectBoxForTemplateType();
      this.isProcessing = false;
    })
  }

  selectBoxForModule() {
    this.moduleDropdown = this.dropdownForModule?.filter((item: any) => item.codelistCode == 'AU' || item.codelistCode == 'OOS').map((item: any) => ({
      valueExp: item.codelistCode,
      displayExp: item.codelistName
    })) ?? []
  }

  onModuleSelect(event: any, item: any) {
    if (event.isUserInput) {
      if (item) {
        this.message.questionnaireModule = item.valueExp;
        this.getcallMethod();
      } else {
        this.message.questionnaireModule = "";
        this.qmsQuestionnaireTemplateDataForGrid = [];
      }
    }
  }
  refreshGridData() {
    this.isProcessing = true;
    this.getcallMethod();
  }

  singleSelectDropdownSetting: IDropdownSettings = {
    idField: 'valueExp',
    textField: 'displayExp',
    enableCheckAll: false,
    allowSearchFilter: true,
    singleSelection: true,
    itemsShowLimit: 1,
  };

  selectedTemplateType: any = null;
  templateTypeListDropdown: any = [];

  focusmethod(value: any) {
    setTimeout(() => {
      let requiredElement = document.getElementById(value);
      requiredElement?.focus();
    }, 0)
  }

  focusSearch(value: any) {
    setTimeout(() => {
      let searchBox = document.getElementById(value);
      searchBox?.focus();
    }, 0)
  }

  selectBoxForTemplateType() {
    this.templateTypeListDropdown = [];

    for (const templateType of this.dropDownDataForTemplateType) {
      this.templateTypeListDropdown = this.templateTypeListDropdown.concat({
        valueExp: templateType.codelistCode,
        displayExp: templateType.codelistName
      });
    }
  }


  templateTypesearchTxt: any;

  onTemplateTypeSelect(event: any, item: any) {
    if (event.isUserInput) {
      if (event.source._selected) {
        if (item) {
          this.selectedTemplateType = item.valueExp;
        }
      } else {
        this.selectedTemplateType = undefined;
      }
    }

  }

  qmsQuestionnaireTemplateFieldData: any = {};
  operationFlag: any;
  popupDataTitle: PopupData = {
    title: ''
  };

  popupTitle: string | null = 'title';
  @ViewChild('addAndEditPopup', { static: true }) addAndEditPopup: TemplateRef<any>;
  @ViewChild('deletePopup', { static: true }) deletePopup: TemplateRef<any>;
  visibleAddAndEditPopup: MatDialogRef<TemplateRef<any>>;
  visibleDeletePopup: MatDialogRef<TemplateRef<any>>;

  addAndEditPopupConfig = {
    width: '75%',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '60px' },
  };

  deletePopupConfig = {
    width: '500px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: false,
    disableClose: true,
    position: { top: '10px' },
  };

  visibleAddButton: boolean;
  visibleEditButton: boolean;

  openAddPopup() {
    this.visibleAddButton = true;
    this.visibleEditButton = false;
    this.operationFlag = 'ADD';
    this.popupDataTitle.title = "Create QMS Questionnaire Template";
    if (this.selectedTemplateType != '') {
      this.selectedTemplateType = null;
    }
    this.qmsQuestionnaireTemplateFieldData.templateName = '';
    this.qmsQuestionnaireTemplateFieldData.isActive = true;
    this.qmsQuestionnaireTemplateFieldData.templateDescription = '';
    this.visibleAddAndEditPopup = this.dialog.open(this.addAndEditPopup, this.addAndEditPopupConfig);
  }

  previousData: any;
  previousDataTemplateId: any;
  getQmsQuestionnaireTemplateDetails: any = [];
  filteredTemplateTypeValue: any = [];
  openEditPopup(qmsQuestionnaireTemplateRowData: any) {
    this.isProcessing = true;
    console.log(qmsQuestionnaireTemplateRowData);
    this.previousData = qmsQuestionnaireTemplateRowData;
    this.visibleAddButton = false;
    this.visibleEditButton = true;
    this.operationFlag = 'EDIT';
    this.popupDataTitle.title = "Update QMS Questionnaire Template";
    this.previousDataTemplateId = qmsQuestionnaireTemplateRowData.TEMPLATE_ID;
    this.appService.getQmsQuestionnaireTemplateDetailsByOrgIdAndTemplateId(this.previousDataTemplateId).subscribe((response: any) => {
      this.getQmsQuestionnaireTemplateDetails = response
      this.qmsQuestionnaireTemplateFieldData.updateReason = '';
      this.qmsQuestionnaireTemplateFieldData.templateId = this.getQmsQuestionnaireTemplateDetails.qmsQuestionnaireTemplatesVwPk.templateId;
      this.qmsQuestionnaireTemplateFieldData.templateName = this.getQmsQuestionnaireTemplateDetails.templateName;
      this.qmsQuestionnaireTemplateFieldData.isActive = this.getQmsQuestionnaireTemplateDetails.isActive == 'Y';
      this.qmsQuestionnaireTemplateFieldData.templateDescription = this.getQmsQuestionnaireTemplateDetails.templateDescription;

      if (this.getQmsQuestionnaireTemplateDetails.templateType) {
        const matchingTemplateType = this.dropDownDataForTemplateType?.find((item: any) => item.codelistCode == this.getQmsQuestionnaireTemplateDetails.templateType);
        if (!matchingTemplateType) {
          this.oddTemplateType = this.getQmsQuestionnaireTemplateDetails.templateType;
          this.templateTypeListDropdown.push({
            valueExp: this.getQmsQuestionnaireTemplateDetails.templateType,
            displayExp: this.getQmsQuestionnaireTemplateDetails.templateType
          })
        }
        this.selectedTemplateType = this.getQmsQuestionnaireTemplateDetails.templateType;
      }
      this.isProcessing = false;
      this.visibleAddAndEditPopup = this.dialog.open(this.addAndEditPopup, this.addAndEditPopupConfig);
    })
  }

  templateNameValue: any;
  templateTypeValue: any;

  templateNameRequiredMsg: any;
  templateTypeRequiredMsg: any;
  updateValue: any;
  updateValueMsg: any;

  fieldValidation() {
    this.templateNameValue = document.getElementById('templateName') as HTMLInputElement;
    this.templateTypeValue = document.getElementById('templateType') as HTMLInputElement;

    this.updateValue = document.getElementById('update-text') as HTMLInputElement;
    this.updateValueMsg = document.getElementById('update-required-msg') as HTMLInputElement;

    this.templateNameRequiredMsg = document.getElementById('templateName-required-msg') as HTMLInputElement;
    this.templateTypeRequiredMsg = document.getElementById('templateType-required-msg') as HTMLInputElement;

    if (this.templateNameValue.value == "") {
      this.templateNameValue.style.border = '1px solid red';
      this.templateNameRequiredMsg.style.display = 'block';
    } else {
      this.templateNameValue.style.border = 'none';
      this.templateNameRequiredMsg.style.display = 'none';
    }
    if (this.visibleEditButton) {
      if (this.updateValue.value) {
        this.updateValue.style.border = 'none';
        this.updateValueMsg.style.display = 'none';
      } else {
        this.updateValue.style.border = '1px solid red';
        this.updateValueMsg.style.display = 'block';
      }
    }

    if (this.selectedTemplateType) {
      this.templateTypeValue.style.border = 'none';
      this.templateTypeRequiredMsg.style.display = 'none';;
    } else {
      this.templateTypeValue.style.border = '1px solid red';
      this.templateTypeRequiredMsg.style.display = 'block'
    }
  }

  openSnackbar: any;
  displayMessage: any;
  errorStatus: any;
  displayResultType: any;
  displaySuccessMessage: boolean;
  displayErrorMessage: boolean;
  addAndEditFunction(qmsQuestionnaireTemplateFieldData: any) {
    console.log("Catch");
    this.isProcessing = true;
    if (!this.selectedTemplateType || this.qmsQuestionnaireTemplateFieldData.templateName == '' || (this.visibleEditButton && !this.qmsQuestionnaireTemplateFieldData.updateReason)) {
      this.fieldValidation();
      this.isProcessing = false;
    } else if (this.operationFlag == 'ADD') {
      qmsQuestionnaireTemplateFieldData.templateName = this.qmsQuestionnaireTemplateFieldData.templateName;
      qmsQuestionnaireTemplateFieldData.isActive = this.qmsQuestionnaireTemplateFieldData.isActive ? "Y" : "N";
      qmsQuestionnaireTemplateFieldData.templateDescription = this.qmsQuestionnaireTemplateFieldData.templateDescription;
      qmsQuestionnaireTemplateFieldData.templateType = this.selectedTemplateType;
      qmsQuestionnaireTemplateFieldData.module = this.selectedModule;
      this.appService.createQmsQuestionnaireTemplate(this.qmsQuestionnaireTemplateFieldData).subscribe({
        next: (Response: any) => {
          this.displayMessage = Response.result;
          this.displayResultType = Response.resultType;
          if (this.displayResultType == 'S') {
            this.visibleAddAndEditPopup.close();
            this.getcallMethod();
          }
          this.isProcessing = false;
          this.snackbarRef = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
            duration: this.displayResultType == 'S' ? 5000 : undefined,
            data: {
              message: Response.result,
              type: Response.resultType == 'S' ? 'Success' : 'Error',
              buttonLabel: "Ok"
            },
            horizontalPosition: 'center',
            verticalPosition: 'top',
            panelClass: Response.resultType == 'S' ? 'Success' : 'Error',
          });
          this.snackbarRef.onAction().subscribe(() => {
            this.snackbarRef.dismiss();
          });
        }, error: (error) => {
          this.displayMessage = error;
          this.displaySuccessMessage = false;
          this.displayErrorMessage = true;
          this.isProcessing = false;
          throw error;
        }
      });
    } else {
      delete qmsQuestionnaireTemplateFieldData.createdOn;
      delete qmsQuestionnaireTemplateFieldData.updatedOn;
      qmsQuestionnaireTemplateFieldData.qmsQuestionnaireTemplatesVwPk = {
        templateId: this.previousDataTemplateId,
      }
      qmsQuestionnaireTemplateFieldData.templateName = this.qmsQuestionnaireTemplateFieldData.templateName;
      qmsQuestionnaireTemplateFieldData.templateDescription = this.qmsQuestionnaireTemplateFieldData.templateDescription;
      qmsQuestionnaireTemplateFieldData.isActive = this.qmsQuestionnaireTemplateFieldData.isActive ? "Y" : "N";
      qmsQuestionnaireTemplateFieldData.templateType = this.selectedTemplateType;
      qmsQuestionnaireTemplateFieldData.module = this.selectedModule;
      this.appService.updateQmsQuestionnaireTemplate(this.qmsQuestionnaireTemplateFieldData).subscribe({
        next: (Response: any) => {
          this.displayMessage = Response.result;
          this.displayResultType = Response.resultType;
          if (this.displayResultType == 'S') {
            this.visibleAddAndEditPopup.close();
            this.getcallMethod();
          }
          this.isProcessing = false;
          this.snackbarRef = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
            duration: this.displayResultType == 'S' ? 5000 : undefined,
            data: {
              message: Response.result,
              type: Response.resultType == 'S' ? 'Success' : 'Error',
              buttonLabel: "Ok",
              pageName: this.message.breadcrumbData.thirdLevel ?? this.message.breadcrumbData.secondLevel
            },
            horizontalPosition: 'center',
            verticalPosition: 'top',
            panelClass: Response.resultType == 'S' ? 'Success' : 'Error',
          });
          this.snackbarRef.onAction().subscribe(() => {
            this.snackbarRef.dismiss();
          });
        }, error: (error) => {
          this.displayMessage = error;
          this.displaySuccessMessage = false;
          this.displayErrorMessage = true;
          this.isProcessing = false;
          throw error;
        }
      });
    }
  }

  cancelAddAndEditFunction() {
    this.visibleAddAndEditPopup.close();
  }

  deleteQmsQuestionnaireTemplateId: any;
  openDeletePopup(deleteRowData: any) {
    console.log(deleteRowData);
    this.operationFlag = 'DELETE';
    this.popupDataTitle.title = "Delete QMS Questionnaire Template";
    this.deleteQmsQuestionnaireTemplateId = deleteRowData.TEMPLATE_ID;
    this.qmsQuestionnaireTemplateFieldData.deleteReason = '';
    this.visibleDeletePopup = this.dialog.open(this.deletePopup, this.deletePopupConfig);
  }

  deleteFieldValue: any;

  deleteFieldValueRequiredMsg: any;
  deleteValidation() {
    this.deleteFieldValue = document.getElementById('deleteTextarea') as HTMLInputElement;
    this.deleteFieldValueRequiredMsg = document.getElementById('deleteTextarea-required-msg') as HTMLInputElement;

    if (this.deleteFieldValue.value == '') {
      this.isProcessing = false;
      this.deleteFieldValue.style.border = '1px solid red';
      this.deleteFieldValueRequiredMsg.style.display = 'block';
    } else {
      this.deleteFieldValue.style.border = 'none';
      this.deleteFieldValueRequiredMsg.style.display = 'none';
    }
  }

  deleteFunction(qmsQuestionnaireTemplateFieldData: any) {
    this.isProcessing = true;
    if (this.qmsQuestionnaireTemplateFieldData.deleteReason == '') {
      this.deleteValidation();
      this.isProcessing = false;
    } else {
      qmsQuestionnaireTemplateFieldData.qmsQuestionnaireTemplatesVwPk = {
        templateId: this.deleteQmsQuestionnaireTemplateId
      };
      qmsQuestionnaireTemplateFieldData.deleteReason = this.qmsQuestionnaireTemplateFieldData.deleteReason;
      this.appService.deleteQmsQuestionnaireTemplate(qmsQuestionnaireTemplateFieldData).subscribe({
        next: (Response: any) => {
          this.displayMessage = Response.result;
          this.displayResultType = Response.resultType;
          if (this.displayResultType == 'S') {
            this.visibleDeletePopup.close();
            this.getcallMethod();
          }
          this.isProcessing = false;
          this.snackbarRef = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
            duration: this.displayResultType == 'S' ? 5000 : undefined,
            data: {
              message: Response.result,
              type: Response.resultType == 'S' ? 'Success' : 'Error',
              buttonLabel: "Ok"
            },
            horizontalPosition: 'center',
            verticalPosition: 'top',
            panelClass: Response.resultType == 'S' ? 'Success' : 'Error',
          });
          this.snackbarRef.onAction().subscribe(() => {
            this.snackbarRef.dismiss();
          });

        }, error: (error) => {
          this.displayMessage = error;
          this.displaySuccessMessage = false;
          this.displayErrorMessage = true;
          this.isProcessing = false;
          throw error;
        }
      });
    }
  }

  cancelDeleteFunction() {
    this.visibleDeletePopup.close();
  }

  sortedColumn: string = '';
  sortDirection: string = 'asc';
  sortColumn(column: string, list: any) {
    if (column === this.sortedColumn) {
      this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
    } else {
      this.sortedColumn = column;
      this.sortDirection = 'asc';
    }
    list.showsort = this.sortDirection;

    this.qmsQuestionnaireTemplateDataForGrid.sort((a: { [x: string]: any; }, b: { [x: string]: any; }) => {
      const key = column;
      const valueA = a[key];
      const valueB = b[key];

      if (valueA! < valueB!) {
        return this.sortDirection === 'asc' ? -1 : 1;
      } else if (valueA! > valueB!) {
        return this.sortDirection === 'asc' ? 1 : -1;
      } else {
        return 0;
      }
    });
    this.setPage(1, 0);
  }

  @ViewChild(DynamicAuditTrailComponent) dynamicAuditTrailComponent!: DynamicAuditTrailComponent;

  openAuditTrail(viewType: any, questionnaire: any) {
    this.auditTrail.refNo = viewType == 'overAll' ? null : questionnaire.TEMPLATE_ID;
    this.auditTrail.gridName = 'QUESTIONNAIRE_TEMPLATE';
    this.auditTrail.report_And_Popup_Name = 'Questionnaire Template Audit Trail';
    this.dynamicAuditTrailComponent.triggerTrail(questionnaire);
  }

  @ViewChild(ExcelPdfComponent) excelPdfComponent!: ExcelPdfComponent;
  excelPdf: any = {};
  reportObj: any = {};

  openReport(reportType: string) {
    this.excelPdf.reportObj = this.reportObj;
    this.excelPdf.reportType = 'Dynamic';
    this.excelPdf.reportName = 'Questionnaire Template Report';
    this.excelPdf.dropDown = this.columnLists?.fieldColumnarray?.map((item: any) => item.fieldColumnarray);
    this.excelPdfComponent.openReportPopup(reportType);
  }

  @ViewChild(GridReorderComponent) gridReorderComponent!: GridReorderComponent;
  openReorder() {
    this.gridReorderComponent.reordercall(this.reportObj.gridName, this.reportObj.tableOrViewName, null, 0)
  }

  onChildValueEmitted() {
    this.getcallMethod();
  };

  dynamicLabel: any = null;
  label: any = [];
  dynamicLabelCall() {
    this.isProcessing = true;
    const data = {
      tableName: this.reportObj.tableOrViewName,
      moduleName: null,
      gridName: this.reportObj.gridName,
      groupId: 0,
    };
    this.appService.getreorderGirdColumnList(data).subscribe({
      next: (data: any) => {
        this.label = data;
        this.dynamicLabel = this.label.reduce((acc: any, user: any) => {
          acc[`${user.columnName}`] = user.changedFieldName;
          return acc;
        }, {});
        this.isProcessing = false;
      }, error: (error: any) => {
        this.isProcessing = false;
      }
    });
  }
  focusEmpty() {
    console.log();
  }
}
